export default __webpack_public_path__ + "static/our-values-3-1663e10a920ebcd592941be8312b2d2f.svg";